import api from "./api";

export const getPaginatedCategories = async (
  params = { page: 1, limit: 10 }
) => {
  const { data } = await api.get("/categories/paginated", { params });
  return data;
};

export const createCategory = async (formData: FormData) => {
  const { data } = await api.post("/categories", formData);
  return data;
};

export const updateCategory = async (slug: string, formData: FormData) => {
  const { data } = await api.put(`/categories/${slug}`, formData);
  return data;
};

export const deleteCategory = async (slug: string) => {
  const { data } = await api.delete(`/categories/${slug}`);
  return data;
};

export const getCategoryById = async (id: string) => {
  const { data } = await api.get(`/categories/${id}`);
  return data;
};

export const getCategoryBySlug = async (slug: string) => {
  const { data } = await api.get(`/categories/slug/${slug}`);
  return data;
};
